export class Header {
    public static calculateResponsiveCenterSlot(): void {
        let leftPosition: number = 0;
        let width: number = 0;

        const leftSlot = $('.navigation_button_container.left');
        leftPosition = leftSlot.is(':visible') ? (leftSlot.width() - 5) : 0;
        width = $('#header').width() - $('.navigation_button_container.dright.right').width() - leftPosition + 4;

        $('.header__center-responsive-slot')
            .css('left', leftPosition)
            .css('width', width);
    }

    public static showLogoutButton(): void {
        const logoutButton = $('#header .navigation_button[data-link="logout"]');
        logoutButton.show();
    }
}
